<template>
    <div>
        <div class="tickets-row__details">
            <Status
                :numEventsLeft="numActiveEvents"
                :status="status"
                :liveIndicator="hasOngoingEvents"
            />
            <div class="tickets-cell played">
                <span>{{ dateReceived | formatDateTime('ddmmyyyyHHMM') }}</span>
            </div>
            <div class="tickets-cell type">
                <span class="bet-type">{{ $t(type) }}</span>
                <span class="delimiter" />
                <span class="bet-system"> {{ `${system ? $t('system') : $t('simple')}` }} </span>
            </div>
            <div class="tickets-cell bet-id">
                <span>{{ id }}</span>
            </div>
        </div>
        <div class="tickets-row__amounts">
            <div
                :title="coefficient"
                class="tickets-cell coefficient"
            >
                <span class="value">{{ coefficient | twoDecimals }}</span>
            </div>
            <div class="tickets-cell stake">
                <span>{{ stake | twoDecimals }}</span>
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
            <div class="tickets-cell payoff">
                <span>{{ potentialWin | twoDecimals }}</span>
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { EventStatus, EventType, TicketType } from '@core/models/tickets/enums';
    import TicketRowMixin from './TicketRowMixin';

    export default {
        mixins: [TicketRowMixin],
        props: {
            events: {
                type: Array,
                required: true,
            },
        },
        computed: {
            ...mapGetters('data/sportOffer', [
                'eventsMap',
            ]),
            numActiveEvents() {
                return this.events.filter((event) => event.status === EventStatus.active).length;
            },
            hasOngoingEvents() {
                return this.type === TicketType.sport
                    && this.events.some((event) =>
                        event.status === EventStatus.active
                        && event.type === EventType.live
                        && this.eventsMap[event.eventId]
                        && this.eventsMap[event.eventId].isOngoing()); // last 2 lines maybe unecessary
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/tickets/components/ActiveTicketRow.vue